import * as Sentry from "@sentry/vue";

const CATEGORY = "app";
// Sentry is only enabled in test/prod (see main.ts). In dev, fall back to the
// console so developers see the same structured signals locally.
const devLog = !["test", "prod"].includes(import.meta.env.VITE_APP_STAGE);

type Level = "info" | "warning" | "error";

export const obs = {
  breadcrumb(message: string, data?: Record<string, unknown>) {
    Sentry.addBreadcrumb({ category: CATEGORY, message, level: "info", data });
    if (devLog) console.debug(`[obs] ${message}`, data ?? "");
  },

  message(message: string, level: Level = "info", data?: Record<string, unknown>) {
    Sentry.withScope((scope) => {
      if (data) scope.setExtras(data);
      scope.setLevel(level);
      Sentry.captureMessage(message, level);
    });
    if (devLog) console.warn(`[obs:${level}] ${message}`, data ?? "");
  },

  captureError(error: unknown, context: string, data?: Record<string, unknown>) {
    Sentry.withScope((scope) => {
      // Tag (indexed → searchable/filterable/alertable in Sentry) plus extras
      // (richer, but not indexed). Search e.g. `context:calculator.fileUpload`.
      scope.setTag("context", context);
      scope.setExtras({ context, ...(data ?? {}) });
      Sentry.captureException(error);
    });
    if (devLog) console.error(`[obs:error] ${context}`, error, data ?? "");
  },
};
